export default __webpack_public_path__ + "static/media/012.f91487ca.jpg";